export default {
  CREATE: `Create an attribute`,
  DELETE_BUTTON: {
    TITLE: `Delete the attribute`,
    SUMMARY: `Are you sure you want to delete this attribute?`,
    PRIMARY_ACTION: `Delete the attribute`
  },
  LIST: {
    TITLE: `Attributes list`,
    SUMMARY: ``
  },
  SELF_ASSIGNABLE: `Self assignable`,
  DESCRIPTION: `Description`,
  LEVELS: `Levels`,
  REMINDERS: `Reminders`,
  LEVEL_DESCRIPTION: `Less qualified to most qualified. (1 lowest qualification, to 10 higly qualified)`,
  TYPE: `Type`,
  RESTRICTION: `Restriction`,
  REQUIREMENT: `Requirement`,
  ALERT: `Alert`,
  SKILL: `Skill`,
  FORMED: `Trained`,
  CSV_EXPORT_NAME: `attributes_export_{{date}}`,
  DAYS: `Days`,
  form: {
    CREATE: {
      TITLE: `Creating attribute`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Editing attribute`,
      SUMMARY: ``
    },
    NAME: {
      LABEL: `Attribute name`,
      DESCRIPTION: `This name should help you quickly identify the attribute.`,
      PLACEHOLDER: `Enter a name for the attribute`
    },
    DESCRIPTION: {
      LABEL: `Attribute description`,
      DESCRIPTION: ``,
      PLACEHOLDER: `Enter a description for the attribute`
    },
    SELFASSIGN: {
      LABEL: `Self assignable`,
      DESCRIPTION: `This will allow users to self assign this attribute through their profile.`
    },
    HASEXPIRATIONDATE: {
      LABEL: `Has an expiration date`,
      DESCRIPTION: `This will allow to send reminders to employees who need to renew their attribute.`
    },
    REMINDERS: {
      LABEL: `Reminder time delay`,
      DESCRIPTION: ``,
      PLACEHOLDER: ``
    },
    HASCUSTOMMESSAGE: {
      LABEL: `Add a custom message`,
      DESCRIPTION: ``
    },
    CUSTOMMESSAGE: {
      LABEL: `Custom message`,
      DESCRIPTION: `Write your custom message in the corresponding language (English under #en, French under #fr)`,
      PLACEHOLDER: ``
    },
    CODE: {
      LABEL: `Import code`,
      DESCRIPTION: `This will be used in the import tools to assign attributes to other resources.`,
      PLACEHOLDER: `Enter the import code`
    },
    TYPE: {
      LABEL: `Attribute type`,
      DESCRIPTION: `There are three attribute types, skills and requirements are functionally identical and required to be eligible for a shift and restrictions can prevent someone from being eligible.`
    },
    RANK: {
      LABEL: `Rank`,
      DESCRIPTION: ``,
      PLACEHOLDER: `Enter the level rank`
    },
    LEVELNAME: {
      LABEL: `Name`,
      DESCRIPTION: ``,
      PLACEHOLDER: `Enter the level name`
    },
    REQUIREACKNOWLEDGEMENT: {
      LABEL: `Acknowledgement requirement`,
      DESCRIPTION: `A popup will be displayed when the employee logs in and notifications will be sent to them every day until they confirm that they are aware of their expiring attributes.`
    },
    SENDCOPYTOCOMPANYEMAIL: {
      LABEL: `Send a copy to the company email`,
      DESCRIPTION: `The reminder will also be sent to the company email address.`
    },
    NAME_REQUIRED: `Attribute's name is mandatory.`,
    TYPE_REQUIRED: `Attribute's type is mandatory.`,
    AT_LEAST_ONE_LEVEL_REQUIRED: `At least one level is required.`,
    AT_LEAST_ONE_REMINDER_REQUIRED: `At least one reminder is required`,
    NAME_ALREADY_USED: `Name already used`,
    LEVELS_UNIQUE: `Level's rank must be unique`
  }
}
